import { Ng2StateDeclaration } from '@uirouter/angular';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { DocumentNavigationTabsComponent } from '@fi-app/document/document-navigation-tabs/document-navigation-tabs.component';

export const FiDocumentRootState: Ng2StateDeclaration = {
    name: FiStateNames.Document._name,
    url: '/Document',
    abstract: true,
    component: DocumentNavigationTabsComponent,
};

export function registerDocumentStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.Document.List, FiStateNames.Document.View], {
        SettingType: [ApplicationSettingsType.DocumentCentral, ApplicationSettingsType.DocumentLocal],
        AccessType: AccessRightType.Read,
    });

    stateAccessCheckService.registerStateRules(
        [FiStateNames.Document.Add, FiStateNames.Document.Edit, FiStateNames.Document.Version],
        {
            SettingType: [ApplicationSettingsType.DocumentCentral, ApplicationSettingsType.DocumentLocal],
            AccessType: AccessRightType.Share,
        },
    );
}
